import { __typename } from "@/actions/__typename.ts";
import { useLazyGetCompatibleExtras } from "@/actions/hooks/useLazyGetCompatibleExtras.ts";
import { Extra, MandatoryExtra } from "@/helpers/types/types.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

export const useGetOptions = (cartItem: CartAccommodationItem) => {
  const { setCartItemMandatoryExtras } = useEngineStore(
    useShallow((state) => ({ setCartItemMandatoryExtras: state.setCartItemMandatoryExtras })),
  );

  const { handleGetCompatibleExtras, compatibleExtras, getExtrasLoading } =
    useLazyGetCompatibleExtras(cartItem);

  useEffect(() => {
    void handleGetCompatibleExtras().then((response) => {
      if (response?.data) {
        const mandatoryExtras = response.data?.compatibleExtras?.filter(
          (extra) => extra.__typename === __typename.MandatoryExtra,
        ) as MandatoryExtra[];

        setCartItemMandatoryExtras(mandatoryExtras, cartItem.id);
      }
    });
  }, [cartItem.id, handleGetCompatibleExtras, setCartItemMandatoryExtras, cartItem.optionalExtras]);

  const optionalExtras = compatibleExtras?.filter(
    (extra) => extra.__typename === __typename.OptionalExtra,
  ) as Extra[];
  const mandatoryExtras = compatibleExtras?.filter(
    (extra) => extra.__typename === __typename.MandatoryExtra,
  ) as MandatoryExtra[];

  return { optionalExtras, mandatoryExtras, getExtrasLoading };
};
